import React from "react";

interface HeaderProps {
  current?: number;
  [key: string]: any;
}

const Header_WorkRequest: React.FC<HeaderProps> = (props) => {
  const { current = 1 } = props;

  return (
    <>
      <div id="wrForms" className="steps clearfix">
        <ul>
          <li className={current >= 1 ? "first done" : "first"}>
            <a href="#wizard-01-h-0" onClick={(ev) => ev.preventDefault()}>
              <div className="step-icon">
                {/* <span className="number">1</span> */}
              </div>
              <div className="step-text">
                <h5>General Information</h5>
                {/* <span>Basic work request details</span> */}
              </div>
            </a>
          </li>
          <li className={current >= 2 ? "done" : ""}>
            <a href="#wizard-01-h-1" onClick={(ev) => ev.preventDefault()}>
              <span className="current-info audible">current step: </span>
              <div className="step-icon">
                {/* <span className="number">2</span> */}
              </div>
              <div className="step-text">
                <h5>Work Request Details</h5>
                {/* <span>Add work lines from different sources</span> */}
              </div>
            </a>
          </li>
          <li className={current === 3 ? "last done" : "last"}>
            <a href="#wizard-01-h-2" onClick={(ev) => ev.preventDefault()}>
              <span className="current-info audible">current step: </span>
              <div className="step-icon">
                {/* <span className="number">3</span> */}
              </div>
              <div className="step-text">
                <h5>Preview & Submit</h5>
                {/* <span>Review and submit work request</span> */}
              </div>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header_WorkRequest;